import { HttpParams } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Directive,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { DefaultUrlSerializer, Params } from '@angular/router';

import { environment } from '@env/environment';

import { GTMService } from '@personal-area/global/gtm';
import { ReferralService } from '@personal-area/global/referral';

interface Urls extends Params {
  global: string;
  IDN: string;
  PAK: string;
  apk: string;
}

@Directive()
export class FBS2Links implements OnInit {
  private _cdRef = inject(ChangeDetectorRef);
  private _referralService = inject(ReferralService);
  private _gtmService = inject(GTMService);
  private _serializer = new DefaultUrlSerializer();

  public readonly urls = signal<Urls>({
    global: environment.mobilePersonalArea.onelink.global,
    IDN: environment.mobilePersonalArea.onelink.indonesia,
    PAK: environment.mobilePersonalArea.onelink.pakistan,
    apk: environment.mobilePersonalArea.apk,
  });

  public readonly excludedGooglePlayCountries = [];

  public ngOnInit(): void {
    let utmParams: Record<string, string> = {};
    const utm = this._referralService.utmParams();

    if (utm) {
      if (utm.utm_source === 'google_web' && utm.utm_medium === 'cpc') {
        utm.utm_source = 'googleadwords_int';
      }

      if (utm.utm_source === 'facebook' && utm.utm_medium === 'cpm') {
        utm.utm_source = 'Facebook%20Ads';
      }

      if (utm.utm_source) {
        utmParams['pid'] = utm.utm_source;
      }

      if (utm.utm_campaign) {
        utmParams['c'] = utm.utm_campaign;
      }

      if (utm.utm_term) {
        utmParams['af_adset'] = utm.utm_term;
      }

      if (utm.utm_content) {
        utmParams['af_ad'] = utm.utm_content;
      }
    }

    utmParams['client_id'] = this._gtmService.currentGoogleClientId;
    utmParams['is_retargeting'] = utm?.utm_campaign?.includes('RTRG') ? 'true' : 'false';

    this.urls.set({
      global: this._buildLinkWithParams(environment.mobilePersonalArea.onelink.global, utmParams),
      IDN: this._buildLinkWithParams(environment.mobilePersonalArea.onelink.indonesia, utmParams),
      PAK: this._buildLinkWithParams(environment.mobilePersonalArea.onelink.pakistan, utmParams),
      apk: this._buildLinkWithParams(environment.mobilePersonalArea.apk, utmParams),
    });

    this._cdRef.markForCheck();
  }

  private _buildLinkWithParams(link: string, utmParams: Record<string, string | boolean | number>): string {
    const urlParams = new HttpParams({
      fromObject: utmParams ?? {}
    });

    const linkParams = this._serializer.parse(link).queryParamMap;
    linkParams.keys.forEach(key => {
      if (!urlParams.has(key)) {
        urlParams.set(key, linkParams.get(key) || '')
      }
    });

    return [link.split('?')[0], urlParams.toString()].join('?');
  }
}
